import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

import { taskListGoalFilterKeys } from './filter-sections';

export const taskListGroupOptions = [
  GroupByMode.None,
  GroupByMode.LifeArea,
  GroupByMode.Goal,
  GroupByMode.Priority,
  GroupByMode.Deadline,
  GroupByMode.DeadlineDeadline,
  GroupByMode.Tag,
  GroupByMode.Type,
] as const satisfies TaskGroupBy[];

export const taskListSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.DeadlineDeadline,
  SortingMode.Name,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];

export const goalTaskListGroupOptions = [
  GroupByMode.Section,
  GroupByMode.Goal,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.Deadline,
  GroupByMode.DeadlineDeadline,
  GroupByMode.Tag,
] as const satisfies TaskGroupBy[];

export const goalTaskListSortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];

export const taskListFilters = Object.values(FilterOptionKeys).filter(
  // GoalType (Goals/Projects) is a goals-overview-only filter; keep it off task
  // lists — only the Timeline opts into it explicitly.
  (filter) =>
    filter !== FilterOptionKeys.CompletedAt &&
    filter !== FilterOptionKeys.GoalType,
) as FilterOptionKeys[];

// Tag-detail is already scoped to one tag, so filtering by Tag there is redundant.
export const tagDetailFilters = taskListFilters.filter(
  (filter) => filter !== FilterOptionKeys.Tag,
);

// Goal- and life-area-detail are scoped to one life area, so filtering by LifeArea is redundant.
export const goalDetailFilters = taskListFilters.filter(
  (filter) => filter !== FilterOptionKeys.LifeArea,
);

export type GoalDetailOptions = {
  hasSubGoals: boolean;
};

// Without sub-goals every task on the list belongs to the goal being viewed.
export const getGoalDetailFilters = ({
  hasSubGoals,
}: GoalDetailOptions): FilterOptionKeys[] =>
  goalDetailFilters.filter(
    (filter) => hasSubGoals || !taskListGoalFilterKeys.includes(filter),
  );

export const getGoalTaskListGroupOptions = ({
  hasSubGoals,
}: GoalDetailOptions): TaskGroupBy[] =>
  goalTaskListGroupOptions.filter(
    (mode) => hasSubGoals || mode !== GroupByMode.Goal,
  );

export const lifeAreaDetailFilters = taskListFilters.filter(
  (filter) => filter !== FilterOptionKeys.LifeArea,
);
